import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import {plusSquareO} from 'react-icons-kit/fa/plusSquareO'
import AutoComp from '../components/AutoComp'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, isEmpty } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function Produtos_Inativos(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [lin, setLin] = useState(0)

  const [comboLinha, setComboLinha] = useState([{ VALUE: '', DISPLAY: '' }])

  const columns = [
    { id: 'CODIGO_MACROPECAS_INATIVO', numeric: false, label: 'Código Macropeças', align: 'left', minWidth: 200 },
    { id: 'NOME_MACROPECAS_INATIVO', numeric: false, label: 'Descrição Macropeças', align: 'left', minWidth: 150 },
    { id: 'CODIGO_MACROPECAS_NOVO', numeric: false, label: 'Código Macropeças Novo', align: 'left', minWidth: 200 },
    { id: 'NOME_MACROPECAS_NOVO', numeric: false, label: 'Nome Macropeças Novo', align: 'left', minWidth: 200 },
    { id: 'CODIGO_REPRESENTADA_NOVO', numeric: false, label: 'Codigo Representada Novo', align: 'left', minWidth: 200 },
    { id: 'NOME_REPRESENTADA_NOVO', numeric: false, label: 'Nome Representada Novo', align: 'left', minWidth: 200 },

  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      setenableAdd(await api.getAcessos('Produtos', 'INCLUSAO'))
      setenableEdit(await api.getAcessos('Produtos', 'ALTERACAO'))
      setenableDel(await api.getAcessos('Produtos', 'EXCLUSAO'))
      setComboLinha(await api.getComboData('linhas_produtos'))


      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    const fetchMdc = async () => {
      const auxValues = { ...filter };
      auxValues["fk_lin"] = lin;
      setFilter(state => auxValues)
      auxValues["nomelin"] = ''
      if (lin > 0) {
        await api.get("/linhas_Produtos?pk_lin=" + lin).then((r) => {
          console.log(lin)
          if (r.data[0])
            auxValues["nomelin"] = r.data[0].NOME;
        });
      }
      setFilter(state => {console.log(state)
        return auxValues})
    };
    fetchMdc();
  }, [lin]);

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    // if (!isEmpty(queryObject)) {
    if (true) {
      queryObject.buscar = true
      setFiltered(true)
      window.history.replaceState({ filtered: true }, 'filter', "/macropecas_app/produtos_inativos?" + objectToQueryString(queryObject));
      swal.fire({
        html: <FrLoading text="Buscando dados..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      api.get('/produtos_inativos', { params: queryObject }).then(r => {
        
        setData(r.data)
        console.log(r.data)
        swal.close()
      })
    } else {
      swal.fire('Nenhum filtro informado!', 'Informe ao menos um filtro para realizar a busca.', 'warning')
    }
  }

  function clearForm(e) {
    e.preventDefault();
    console.log('limpa');
    window.history.replaceState({ filtered: false }, 'filter', '/macropecas_app/produtos');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    console.log(auxValues)
    auxValues[e.target.name] = e.target.value;
    setFilter(auxValues);
  };

  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Produtos</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrTextInput
                value={filter.codigo_macropecas || ''}
                style={{ width: 350 }}
                name="codigo_macropecas"
                id="codigo_macropecas"
                color="#389492"
                label="Código do Macropecas"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />
              
              {/* <br/> */}
            <FrTextInput
                value={filter.nome_macropecas || ''}
                style={{ width: 600 }}
                name="nome_macropecas"
                id="nome_macropecas"
                color="#389492"
                label="Nome Macropecas"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />
              

            </div>
            <div>
            <FrTextInput
                value={filter.codigo_representada || ''}
                style={{ width: 350 }}
                name="codigo_representada"
                id="codigo_representada"
                color="#389492"
                label="Código Representada"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />
              
              {/* <br/> */}
            <FrTextInput
                value={filter.nome_representada || ''}
                style={{ width: 600 }}
                name="nome_representada"
                id="nome_representada"
                color="#389492"
                label="Nome Representada"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />
            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              {enableAdd !== 'S' ? '' :
                <Link to="/macropecas_app/produtos/registro">
                  <button >
                    <Icon icon={ic_add_box} size={18} />
                  Novo Registro
                </button>
                </Link>}
            </div>
          </form>
        </div>
        <br />
        <div className="tableDiv">
          <FrTable 
            detail={true}
            regName="produtos"
            detailName="produtos_inativos" 
            columns={columns} 
            uploadFotos 
            width={150}
            searched={filtered} 
            codeName="PK_PRO" 
            page={'Produtos inativos'} 
            data={data} 
            readOnly
            // enableEdit={enableEdit} 
            // enableDel={enableDel} 
          />
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Produtos_Inativos;
